<template>
    <NoButtonModal :open="open" @close="cancel" id="the_new_client_dropdown_modal">
        <div class="modal-list-third-party-app">
            <ejs-tooltip class="tooltipcontainer" content="Close" target="#target" cssClass="customtooltip">
                <span
                    id="target"
                    class="material-symbols-outlined btn-popup-close-preview ms-2 rounded-circle"
                    role="button"
                    @click="cancel"
                    >close</span
                >
            </ejs-tooltip>

            <div>
                <div class="" v-if="pageData.page4.template">
                    <div class="w-100 primeContainer">
                        <div class="bgImageContainer">
                            <img
                                src="@/assets/px/drag-and-drop/MHH-FC-Background.png"
                                alt=""
                                class="bgImage"
                                width="100"
                                height="100"
                            />
                        </div>
                        <div class="w-100 primeContainer">
                            <div class="px-5 pt-4">
                                <div class="d-flex justify-content-between w-100 align-items-center">
                                    <div class="d-flex w-70 align-items-center gap-3">
                                        <img src="@/assets/photos/MHH-user.png" alt="" class="user-image" />
                                        <div>
                                            <h1 class="weight-700" style="color: #5155c3">
                                                Hello, <span style="color: #4cbc9a">Jaron William</span>
                                            </h1>
                                            <h3 style="color: #271e4a">Tuesday, November 28, 2023, 10:23 AM</h3>
                                        </div>
                                    </div>
                                    <div class="w-30 d-flex flex-row-reverse gap-4">
                                        <div class="d-flex icon-container">
                                            <img
                                                src="@/assets/px/header-icons-images/logout.svg"
                                                alt=""
                                                width="30"
                                                height="30"
                                            />
                                            <span>Logout</span>
                                        </div>
                                        <div class="d-flex icon-container">
                                            <img
                                                src="@/assets/px/header-icons-images/notification.svg"
                                                alt=""
                                                width="30"
                                                height="30"
                                            />
                                            <span>Notifications</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="t-m-c templateMainContainer pt-0">
                                <div class="u-l-c w-100 d-flex h-100 mb-5 gap-1">
                                    <div
                                        class="w-50 px-2 my-4 gap-3"
                                        style="
                                            align-items: center;
                                            place-items: center;
                                            display: grid;
                                            grid-template-columns: repeat(2, 1fr);
                                            grid-template-rows: repeat(2, 1fr);
                                        "
                                    >
                                        <div
                                            v-for="item in moduleItems"
                                            :key="item[1].name + ''"
                                            class="left-sidebar"
                                            :class="item[1].class"
                                            :style="item[1].style"
                                        >
                                            <draggable
                                                class="draggable-list"
                                                :list="pageData.page4.template['LI'][item[0]].elements"
                                                :group="
                                                    pageData.page4.template['LI'][item[0]].group
                                                        ? pageData.page4.template['LI'][item[0]].group
                                                        : { name: 'myGroup', pull: false, put: true }
                                                "
                                            >
                                                <div
                                                    v-for="value in pageData.page4.template['LI'][item[0]].elements"
                                                    :class="value.class"
                                                    :key="value.name"
                                                    class="li-items-container"
                                                >
                                                    <img
                                                        v-if="value.function_type == 'generic'"
                                                        :src="value.image"
                                                        alt=""
                                                        :class="
                                                            pageData.page4.template['LI'][item[0]].title
                                                                ? 'w-50 h-50'
                                                                : 'w-90'
                                                        "
                                                    />
                                                    <img
                                                        v-else-if="['3rdParty', 'core'].includes(value.function_type)"
                                                        :src="value.image"
                                                        alt=""
                                                        class="w-50 h-50"
                                                    />
                                                    <img v-else :src="value.image" alt="" class="w-70" />
                                                    <p
                                                        v-if="pageData.page4.template['LI'][item[0]].title"
                                                        class="widget-title"
                                                    >
                                                        {{ pageData.page4.template['LI'][item[0]].title }}
                                                    </p>
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>

                                    <div class="w-25 p-2 d-flex flex-column my-4 gap-3">
                                        <div
                                            v-for="(item, index) in callBtnItems"
                                            :key="item[1].name + ''"
                                            class="left-sidebar"
                                            :class="(index === 0 ? 'h-80 ' : 'h-50 ') + item[1].class"
                                            :style="item[1].style"
                                        >
                                            <draggable
                                                class="draggable-list"
                                                :list="pageData.page4.template['LI'][item[0]].elements"
                                                :group="
                                                    pageData.page4.template['LI'][item[0]].group
                                                        ? pageData.page4.template['LI'][item[0]].group
                                                        : { name: 'myGroup', pull: false, put: true }
                                                "
                                            >
                                                <div
                                                    v-for="value in pageData.page4.template['LI'][item[0]].elements"
                                                    :class="value.class"
                                                    :key="value.name"
                                                    class="li-items-container"
                                                >
                                                    <div
                                                        class="w-100 h-100 d-flex align-items-center justify-content-center gap-1"
                                                        :class="index === 0 ? 'flex-column' : ''"
                                                    >
                                                        <img
                                                            v-if="pageData.page4.template['LI'][item[0]].title"
                                                            :src="value.image"
                                                            alt=""
                                                            :class="index !== 0 ? 'w-30' : 'w-40 h-50'"
                                                        />
                                                        <img
                                                            v-else
                                                            :src="value.image"
                                                            alt=""
                                                            :class="index === 0 ? 'w-70' : 'w-50'"
                                                        />
                                                        <p
                                                            v-if="pageData.page4.template['LI'][item[0]].title"
                                                            class="widget-title"
                                                            :class="index !== 0 ? 'horizontal-title' : ''"
                                                        >
                                                            {{ pageData.page4.template['LI'][item[0]].title }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>

                                    <div class="w-25 my-4 p-2 side-container">
                                        <div
                                            v-for="item in Object.entries(pageData.page4.template.GSI)"
                                            :key="item[1].name + ''"
                                            :class="'side-container-item ' + item[1].class"
                                            :style="item[1].style"
                                        >
                                            <draggable
                                                class="draggable-list"
                                                :list="pageData.page4.template['GSI'][item[0]].elements"
                                                :group="
                                                    pageData.page4.template['GSI'][item[0]].group
                                                        ? pageData.page4.template['GSI'][item[0]].group
                                                        : { name: 'myGroup', pull: false, put: true }
                                                "
                                            >
                                                <div
                                                    v-for="value in pageData.page4.template['GSI'][item[0]].elements"
                                                    class="li-items-container flex-row"
                                                    :class="value.class"
                                                    :key="value.name"
                                                >
                                                    <div
                                                        class="w-100 h-100 d-flex align-items-center justify-content-center gap-1"
                                                    >
                                                        <p
                                                            v-if="pageData.page4.template['GSI'][item[0]].title"
                                                            class="horizontal-title"
                                                        >
                                                            {{ pageData.page4.template['GSI'][item[0]].title }}
                                                        </p>
                                                        <img
                                                            v-if="pageData.page4.template['GSI'][item[0]].title"
                                                            class="w-30"
                                                            :src="value.image"
                                                            alt=""
                                                        />
                                                        <img v-else :src="value.image" alt="" class="w-50" />
                                                    </div>
                                                </div>
                                            </draggable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex w-100 align-items-center position-absolute" style="bottom: 0; left: 0">
                                <img
                                    src="@/assets/px/drag-and-drop/footer.png"
                                    alt=""
                                    class="w-100"
                                    style="max-height: 4rem; border-radius: 0 0 14px 14px"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ### Custom Loader ### -->
        <div v-if="showLoader" class="d-flex flex-column justify-content-center align-items-center loader-main">
            <b-spinner variant="primary" class="add-list-function-loader mb-1"></b-spinner>
            <span class="ms-3">Loading ...</span>
        </div>
    </NoButtonModal>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal';
    import draggable from 'vuedraggable';

    export default {
        name: 'PreviewModalMHH_3CallButton',
        components: { NoButtonModal, draggable },
        props: {
            open: {
                type: Boolean,
                required: true,
            },
            selected: {
                type: String,
            },
            pageData: {
                type: Object,
                required: true,
            },
            applicationFrame: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                showLoader: false,
            };
        },
        computed: {
            moduleItems() {
                return Object.entries(this.pageData.page4.template.LI).slice(0, 4);
            },
            callBtnItems() {
                return Object.entries(this.pageData.page4.template.LI).slice(4);
            },
        },
        methods: {
            cancel() {
                this.$emit('close');
            },
        },
    };
</script>

<style scoped>
    .bgImage {
        width: 100%;
        height: 100%;
        overflow: hidden;
        object-fit: cover;
        -o-object-fit: fill;
    }

    .user-image {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 2px solid #5155c3;
        padding: 0.2rem;
    }

    .primeContainer {
        --mini-display-width: 790px;
        --mini-display-width-numeric: 800;
        --upper-layout-container-height: 72%;
        --bottom-info-container-height: 6%;
        width: -moz-fit-content;
        width: max-content;
        position: relative;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }

    .bgImageContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        border-radius: 0 0 14px 14px;
    }

    .templateMainContainer {
        padding: 0.8rem 0.6rem 0 1rem;
        width: var(--mini-display-width);
        display: flex;
        flex-direction: column;
        height: calc(var(--mini-display-width) * (800 / 1400));
        justify-content: space-around;
    }

    .left-sidebar {
        box-shadow: 5px 10px 5px 5px rgba(0, 0, 0, 0.07), 0px 6px 4px 0px rgba(255, 255, 255, 0.07) inset;
        border-radius: 35px;
        width: 13rem;
        height: 90%;
    }

    .widget-list {
        width: 25%;
        min-width: 18rem;
        border: 1px solid rgb(193, 187, 187);
    }

    .widget-list-header {
        background: #f1f7ff;
        font-weight: bold;
        border-radius: 14px 14px 0 0;
        margin-bottom: 0;
    }

    .widgets-list {
        grid-template-columns: repeat(2, 1fr);
        row-gap: 1rem;
        height: 525px !important;
        overflow: auto;
    }

    .draggable-list {
        height: 100%;
        width: 100%;
    }

    .widget-title {
        height: 20px;
        width: 85%;
        margin-top: 0.5rem;
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        text-transform: capitalize;
        font-size: medium;
    }

    .horizontal-title {
        height: auto;
        width: 85%;
        max-width: 50%;
        overflow: hidden;
        display: -webkit-box !important;
        -webkit-line-clamp: 2;
        line-clamp: 2; /* Standard property for compatibility */
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        font-size: medium;
        text-align: center;
        white-space: normal;
        margin-bottom: 0;
    }

    .icon-container {
        color: #271e4a;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 5px;
        font-weight: 600;
    }

    .side-container {
        display: flex;
        gap: 30px;
        flex-direction: column;
        justify-content: space-between;
    }

    .side-container-item {
        height: 30%;
        background-color: white;
        border-radius: 35px;
        box-shadow: 5px 10px 5px 5px rgba(0, 0, 0, 0.07), 0px 6px 4px 0px rgba(255, 255, 255, 0.07) inset;
    }

    .li-items-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 35px;
        height: 100%;
    }

    .li-items-container > img {
        border-radius: 0.5rem;
    }
</style>
